var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlagDe = function SvgIconFlagDe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.1,
    fill: "#D7D7D7",
    stroke: "#E7E7E7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M4.465 9.333h15.07C18.436 6.228 15.482 4 12 4S5.564 6.228 4.465 9.333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D00",
    d: "M4 12c0 .937.17 1.831.465 2.667h15.07c.296-.836.465-1.73.465-2.667a8 8 0 0 0-.465-2.667H4.465A8 8 0 0 0 4 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE00",
    d: "M19.535 14.667H4.465C5.565 17.771 8.518 20 12 20s6.436-2.229 7.535-5.333"
  }))));
};
export { SvgIconFlagDe as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBzdHJva2U9IiNFN0U3RTciLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4LjEiIGZpbGw9IiNEN0Q3RDciIHN0cm9rZT0iI0U3RTdFNyIgc3Ryb2tlLXdpZHRoPSIuMiIvPjxwYXRoIGZpbGw9IiMwMjAzMDMiIGQ9Ik00LjQ2NSA5LjMzM2gxNS4wN0MxOC40MzYgNi4yMjggMTUuNDgyIDQgMTIgNFM1LjU2NCA2LjIyOCA0LjQ2NSA5LjMzMyIvPjxwYXRoIGQ9Ik00IDEyYzAgLjkzNy4xNyAxLjgzMS40NjUgMi42NjdoMTUuMDdjLjI5Ni0uODM2LjQ2NS0xLjczLjQ2NS0yLjY2N2E3Ljk2IDcuOTYgMCAwMC0uNDY1LTIuNjY3SDQuNDY1QTcuOTg1IDcuOTg1IDAgMDA0IDEyIiBmaWxsPSIjRDAwIi8+PHBhdGggZD0iTTE5LjUzNSAxNC42NjdINC40NjVDNS41NjUgMTcuNzcxIDguNTE4IDIwIDEyIDIwczYuNDM2LTIuMjI5IDcuNTM1LTUuMzMzIiBmaWxsPSIjRkZDRTAwIi8+PC9nPjwvc3ZnPg==";